<app-header [user]="user()" />

<div class="www-contact pb-5">
  <section class="www-contact__con">
    @if (user()) {
      <form
        [formGroup]="formGroupLoggedIn"
        [ngxsFormClearOnDestroy]="_isBrowser"
        [ngxsFormDebounce]="20"
        [ngxsForm]="'contact.formLoggedIn'"
        class="www-form www-contact__con__form"
        appInvalidControlScroll
        [appAnimate]="'fadeInLeft'"
        [speed]="'fast'"
      >
        <h3 class="www-contact__con__form__ti">Kontakt</h3>

        <div class="row">
          <div class="col-12">
            <div class="group group--select">
              <ng-select
                [appInputValidator]="fLoggedIn.subject"
                [clearable]="false"
                [closeOnSelect]="true"
                [dropdownPosition]="'bottom'"
                [formControlName]="'subject'"
                [loading]="loading()"
                [multiple]="false"
                [notFoundText]="'Nie znaleziono wyników'"
                [typeToSearchText]="'Zacznij pisać aby wyszukać'"
                [virtualScroll]="true"
                [id]="'subject'"
              >
                @for (s of contactSubjects(); track s.id) {
                  <ng-option [value]="s.id">
                    {{ s.subject }}
                  </ng-option>
                }
              </ng-select>
              <label [for]="'subject'">Temat pytania*</label>
            </div>
            <app-validate-message [control]="fLoggedIn.subject" />
          </div>

          <div class="col-12">
            <div class="group">
              <textarea
                [appInputValidator]="fLoggedIn.message"
                [formControlName]="'message'"
                [id]="'message'"
                rows="5"
              ></textarea>
              <label [for]="'message'">Wiadomość*</label>
            </div>
            <app-validate-message [control]="fLoggedIn.message" />
          </div>

          <div class="col-12 mt-4">
            <p class="www-contact__con__form__con__des">
              Administratorem danych osobowych jest L’Oréal Polska Sp. z o.o., z siedzibą w Warszawie (00-844) przy ul.
              Grzybowskiej 62.
              @if (!clouseExpanded()) {
                <a class="exp" (click)="clouseExpanded.set(!clouseExpanded())">
                  {{ clouseExpanded() ? '[MNIEJ]' : '[WIĘCEJ]' }}</a
                >
              }
              @if (clouseExpanded()) {
                <div [appAnimate]="'landing'" [speed]="'faster'">
                  Kontakt z administratorem możliwy jest za pośrednictwem adresu e-mail: personal-da&#64;loreal.com.
                  Przetwarzanie danych osobowych będzie się odbywać na podstawie prawnie uzasadnionego interesu
                  administratora danych, którym jest udzielenie odpowiedzi na kontakt zainicjowany przez wypełnienie i
                  wysłanie formularza kontaktu. Dane osobowe nie będą udostępniane na rzecz innych podmiotów bez
                  uprzedniej zgody wyrażonej przez podmiot danych. Dane osobowe mogą być udostępnianie podmiotom do tego
                  upoważnionym na podstawie przepisów prawa. Dane osobowe będą przechowywane przez okres niezbędny dla
                  świadczenia usługi, nie dłużej niż 3 miesiące od momentu wysłania przez Administratora odpowiedzi na
                  zapytanie. Podmiotom danych przysługuje prawo dostępu do treści swoich danych oraz prawo ich
                  sprostowania, usunięcia, ograniczenia przetwarzania, przeniesienia, wniesienia sprzeciwu. Przysługuje
                  również prawo wniesienia skargi do Urzędu Ochrony Danych Osobowych, gdy podmiot danych uzna, iż
                  przetwarzanie danych osobowych jego dotyczących narusza przepisy ogólnego rozporządzenia o ochronie
                  danych osobowych z dnia 27 kwietnia 2016 r. Podanie danych osobowych jest dobrowolne, ale niezbędne
                  dla realizacji ww. wskazanego celu. <br /><br />
                  Informujemy, że zgoda na przetwarzanie danych osobowych do wskazanych powyżej celów może zostać
                  wyrażona przez osobę, która ukończyła 16 lat. Aby dowiedzieć się więcej o tym, w jaki sposób
                  wykorzystywane są dane osobowe należy zapoznać się z naszą Polityką prywatności.
                  <a class="exp" (click)="clouseExpanded.set(!clouseExpanded())">
                    {{ clouseExpanded() ? '[MNIEJ]' : '[WIĘCEJ]' }}</a
                  >
                </div>
              }
            </p>
          </div>
        </div>

        <div class="row www-contact__btn my-4">
          <div class="col-12">
            <button
              (click)="onSubmit()"
              class="www-black-btn"
              appGtmClick
              [layer]="{
                event: 'uaevent',
                ecommerce: 'undefined',
                eventCategory: 'newsletter',
                eventAction: 'select::subscribe',
                eventLabel: 'subscribe newsletter',
                event_name: 'body_button_click',
                module_name: 'newsletter',
                cta_name: 'subscribe newsletter',
                link_url: '',
              }"
            >
              Wyślij wiadomość
            </button>
          </div>
        </div>
      </form>
    } @else {
      <form
        [formGroup]="formGroupNotLoggedIn"
        [ngxsFormClearOnDestroy]="_isBrowser"
        [ngxsFormDebounce]="20"
        [ngxsForm]="'contact.formNotLoggedIn'"
        class="www-form www-contact__con__form"
        appInvalidControlScroll
        [appAnimate]="'fadeInLeft'"
        [speed]="'fast'"
      >
        <h3 class="www-contact__con__form__ti">Kontakt</h3>

        <div class="row">
          <div class="col-12">
            <div class="group">
              <input
                [appInputValidator]="fNotLoggedIn.saloonCode"
                [formControlName]="'saloonCode'"
                id="saloonCode"
                type="text"
                autocomplete="off"
              />
              <label for="saloonCode">Kod Klienta L’Oreal</label>
            </div>
            <app-validate-message [control]="fNotLoggedIn.saloonCode" />
          </div>
          <div class="col-12">
            <div class="group">
              <input
                [appInputValidator]="fNotLoggedIn.firstname"
                [formControlName]="'firstname'"
                id="firstname"
                type="text"
                autocomplete="off"
              />
              <label for="firstname">Imię *</label>
            </div>
            <app-validate-message [control]="fNotLoggedIn.firstname" />
          </div>
          <div class="col-12">
            <div class="group">
              <input
                [appInputValidator]="fNotLoggedIn.lastname"
                [formControlName]="'lastname'"
                id="lastname"
                type="text"
                autocomplete="off"
              />
              <label for="lastname">Nazwisko *</label>
            </div>
            <app-validate-message [control]="fNotLoggedIn.lastname" />
          </div>
          <div class="col-12">
            <div class="group">
              <input
                [appInputValidator]="fNotLoggedIn.email"
                [formControlName]="'email'"
                id="email"
                type="email"
                autocomplete="off"
              />
              <label for="lastname">E-mail *</label>
            </div>
            <app-validate-message [control]="fNotLoggedIn.email" />
          </div>
          <div class="col-12">
            <div class="group">
              <input
                [appInputValidator]="fNotLoggedIn.phone"
                [formControlName]="'phone'"
                id="phone"
                type="text"
                autocomplete="off"
                [mask]="'000 000 000'"
                prefix="+48 "
                [dropSpecialCharacters]="true"
              />
              <label for="phone">Numer telefonu *</label>
            </div>
            <app-validate-message [control]="fNotLoggedIn.phone" />
          </div>
          <div class="col-12">
            <div class="group">
              <input
                class="used"
                [appInputValidator]="fNotLoggedIn.zipCode"
                [formControlName]="'zipCode'"
                [mask]="'00-000'"
                [dropSpecialCharacters]="false"
                id="zipCode"
                type="text"
              />
              <label for="zipCode">Kod pocztowy *</label>
            </div>
          </div>

          <div class="col-12">
            <div class="group group--select">
              <ng-select
                [appInputValidator]="fNotLoggedIn.subject"
                [clearable]="false"
                [closeOnSelect]="true"
                [dropdownPosition]="'bottom'"
                [formControlName]="'subject'"
                [loading]="loading()"
                [multiple]="false"
                [notFoundText]="'Nie znaleziono wyników'"
                [typeToSearchText]="'Zacznij pisać aby wyszukać'"
                [virtualScroll]="true"
                id="subject"
              >
                @for (s of contactSubjects(); track s.id) {
                  <ng-option [value]="s.id">
                    {{ s.subject }}
                  </ng-option>
                }
              </ng-select>
              <label for="subject">Temat pytania*</label>
            </div>
            <app-validate-message [control]="fNotLoggedIn.subject" />
          </div>

          <div class="col-12">
            <div class="group">
              <textarea
                [appInputValidator]="fNotLoggedIn.message"
                [formControlName]="'message'"
                id="message"
                rows="5"
              ></textarea>
              <label for="message">Wiadomość*</label>
            </div>
            <app-validate-message [control]="fNotLoggedIn.message" />
          </div>

          <div class="col-12 mt-4">
            <p class="www-contact__con__form__con__des">
              Administratorem danych osobowych jest L’Oréal Polska Sp. z o.o., z siedzibą w Warszawie (00-844) przy ul.
              Grzybowskiej 62.
              @if (!clouseExpanded()) {
                <a class="exp" (click)="clouseExpanded.set(!clouseExpanded())">
                  {{ clouseExpanded() ? '[MNIEJ]' : '[WIĘCEJ]' }}</a
                >
              }
              @if (clouseExpanded()) {
                <div [appAnimate]="'landing'" [speed]="'faster'">
                  Kontakt z administratorem możliwy jest za pośrednictwem adresu e-mail: personal-da&#64;loreal.com.
                  Przetwarzanie danych osobowych będzie się odbywać na podstawie prawnie uzasadnionego interesu
                  administratora danych, którym jest udzielenie odpowiedzi na kontakt zainicjowany przez wypełnienie i
                  wysłanie formularza kontaktu. Dane osobowe nie będą udostępniane na rzecz innych podmiotów bez
                  uprzedniej zgody wyrażonej przez podmiot danych. Dane osobowe mogą być udostępnianie podmiotom do tego
                  upoważnionym na podstawie przepisów prawa. Dane osobowe będą przechowywane przez okres niezbędny dla
                  świadczenia usługi, nie dłużej niż 3 miesiące od momentu wysłania przez Administratora odpowiedzi na
                  zapytanie. Podmiotom danych przysługuje prawo dostępu do treści swoich danych oraz prawo ich
                  sprostowania, usunięcia, ograniczenia przetwarzania, przeniesienia, wniesienia sprzeciwu. Przysługuje
                  również prawo wniesienia skargi do Urzędu Ochrony Danych Osobowych, gdy podmiot danych uzna, iż
                  przetwarzanie danych osobowych jego dotyczących narusza przepisy ogólnego rozporządzenia o ochronie
                  danych osobowych z dnia 27 kwietnia 2016 r. Podanie danych osobowych jest dobrowolne, ale niezbędne
                  dla realizacji ww. wskazanego celu. <br /><br />
                  Informujemy, że zgoda na przetwarzanie danych osobowych do wskazanych powyżej celów może zostać
                  wyrażona przez osobę, która ukończyła 16 lat. Aby dowiedzieć się więcej o tym, w jaki sposób
                  wykorzystywane są dane osobowe należy zapoznać się z naszą Polityką prywatności.
                  <a class="exp" (click)="clouseExpanded.set(!clouseExpanded())">
                    {{ clouseExpanded() ? '[MNIEJ]' : '[WIĘCEJ]' }}</a
                  >
                </div>
              }
            </p>
          </div>
        </div>

        <div class="row www-contact__btn my-4">
          <div class="col-12">
            <button (click)="onSubmit()" class="www-black-btn">Wyślij wiadomość</button>
          </div>
        </div>
      </form>
    }

    <div class="www-contact__con__rig">
      <picture>
        <source media="(max-width:402px)" srcset="assets/images/woman-mb.webp" />
        <img
          class="www-contact__con__rig__img h-auto"
          [priority]="true"
          alt="woman"
          ngSrc="assets/images/woman-ds.webp"
          [fill]="true"
        />
      </picture>
    </div>
  </section>
</div>
